import { IOverviewPagination } from ".";
import { OVERVIEW_URL } from "../../utils/helpers/api.routes";
import { requests } from "../../utils/helpers/api.services";

export const OverviewService = {
  getAllLists: (params: IOverviewPagination) =>
    requests.get(`${OVERVIEW_URL}`, params),
};
